<div
  class="combined-table-head"
  stick
  [cHead]="cHead"
  [cTableBody]="combTableBody"
  (headerIsStuck)="headerStickinessChanged($event)"
>
  <div class="comp-table-fixed-col-header">
    <school-comp-table-fixed-col-header
      [district]="district"
      class="fixed-col-header"
    ></school-comp-table-fixed-col-header>
  </div>
  <div class="comp-table-head" #compHead>
    <school-comp-table-head
      [panels]="panels"
      [columns]="columns"
      [districtOverall]="districtOverall"
      [district]="district"
      [sortCol]="sortCol"
      [sortDirection]="sortDirection"
      [districtColors]="districtColors"
      (sortColumnClicked)="sortColumn($event)"
    ></school-comp-table-head>
  </div>
</div>
<div class="combined-table-body" #combinedTableBody>
  <div class="comp-table-fixed-col">
    <school-comp-table-fixed-col
      [schools]="schools | slice: lowerBound:upperBound"
      (rowHoveredEvent)="fixedColRowHovered($event)"
      [bodyRowHoveredIndex]="bodyRowHoveredIndex"
    ></school-comp-table-fixed-col>
  </div>
  <div
    class="comp-table-body"
    #compBody
    [ngClass]="{ 'hovered-body': fixedColRowHoveredIndex != null }"
    scroll
    [cHead]="cHead"
    (scroll)="onScroll($event)"
  >
    <school-comp-table-body
      [columns]="columns"
      [schools]="schools | slice: lowerBound:upperBound"
      [district]="district"
      (rowHoveredEvent)="bodyRowHovered($event)"
      [fixedColRowHoveredIndex]="fixedColRowHoveredIndex"
    ></school-comp-table-body>
  </div>
</div>
<mat-paginator
  [length]="schools.length"
  [pageSize]="pageSize"
  [pageSizeOptions]="[50, 100, 250, 500]"
  [showFirstLastButtons]="true"
  (page)="onPaginate($event)"
  data-cy="SchoolsPaginator"
  #scPaginator
>
</mat-paginator>
<img
  *ngIf="showRightArrow"
  src="../../assets/images/{{ rightArrowImgName }}.svg"
  (click)="arrowClicked('right')"
  (mouseenter)="highlightArrow('enter', 'right')"
  (mouseleave)="highlightArrow('leave', 'right')"
  class="keyboard-arrow-right"
  [ngClass]="{
    'stuck-header-arrow': headerIsStuck,
    'unstuck-header-arrow': !headerIsStuck,
    'long-page-keyboard-arrow': isLongPage,
    'keyboard-arrow': !isLongPage
  }"
/>
<img
  *ngIf="showLeftArrow"
  src="../../assets/images/{{ leftArrowImgName }}.svg"
  (click)="arrowClicked('left')"
  (mouseenter)="highlightArrow('enter', 'left')"
  (mouseleave)="highlightArrow('leave', 'left')"
  class="keyboard-arrow-left"
  [ngClass]="{
    'stuck-header-arrow': headerIsStuck,
    'unstuck-header-arrow': !headerIsStuck,
    'long-page-keyboard-arrow': isLongPage,
    'keyboard-arrow': !isLongPage
  }"
/>
